import React, { ReactElement } from "react";
import { LinealGauge } from "../../../layout/gauges/LinealGauge";
import { formatPingTime } from "../../../../helper/unitsFormatting";
import t from "../../../../helper/t";

export const PingPending = (): ReactElement => {
  return (
    <div>
      <div className="measurement-speed-display">
        <p>{t("Ping")}</p>
        <span className="speed-display-number">--</span>
      </div>
    </div>
  )
};

export const PingRunning = (): ReactElement => {
  return (
    <div className="server-pc">
      <div className="server-text">{t("Unser Server")}</div>
      <div className="pc-text">{t("Dein Computer")}</div>
      <div className="mobile-text">{t("Dein Smartphone")}</div>
      <div className="speedtest-server-pc-gif">
        <img src="/img/measurement/messung_ping.gif" alt="messung-ping" />
      </div>
      <div className="speedtest-server-mobile-gif">
        <img
          src="/img/measurement/messung_ping_mobile.gif"
          alt="messung-ping-mobile"
        />
      </div>
      <div className="messen-aktuell">
        {t("Ping_Line_1")}
        <br />
        {t("Ping_Line_2")}
      </div>
    </div>
  )
};

interface PingFinishedProps {
  actualPingTime: number, // in seconds
  isCustomer: boolean
}

export const PingFinished: React.FC<PingFinishedProps> = ({
  actualPingTime,
  isCustomer
}) => {
  const pingTimeFormatted = formatPingTime(actualPingTime)
  
  return (
    <div data-cy="card-ping-finished" className="measurement-speed-display">
      <p>Ping</p>
      {!isCustomer ? (
        <>
          <span className="info-text">
            {t("Reaktionszeit Deines Anschlusses")}
            <br />
            {pingTimeFormatted} {t("Millisekunden")}
          </span>

          <div className="measurement-speed-display-number">
            <p id="pingMeasurementValue">
              <span className="active-original no-customer-label">{pingTimeFormatted}</span> &nbsp; {t("ms")}
            </p>
          </div>
        </>
      ) : (
        <>
          <span className="info-text-ping">
            {t("Reaktionszeit Deines Anschlusses")}
            <br />
            {pingTimeFormatted} {t("Millisekunden")}
          </span>

          <div className="lineal-slider">
            <LinealGauge actualSpeed_bps={/* TODO: Decide what should the LinealGauge show for ping */ 0} bookedSpeed_bps={null} />
            <div id="pingMeasurementValue" className="gauge-lineal-label">
              {pingTimeFormatted}
            </div>
            <div className="gauge-lineal-units">{t("ms")}</div>
            <div className="gauge-lineal-content" />
          </div>
        </>
      )
      }
    </div >
  )
};